
export default class LocalDataManager {

    constructor() {

        this.init = this.init.bind(this);
        this.dbExist = this.dbExist.bind(this);

        this.getAuthInfo = this.getAuthInfo.bind(this);
        this.getAccountInfo = this.getAccountInfo.bind(this);
        this.getSettingsInfo = this.getSettingsInfo.bind(this);
        this.getSetting = this.getSetting.bind(this);
        this.getBlastLocationDataQuery = this.getBlastLocationDataQuery.bind(this);
        this.getBlastEmployeeDataQuery = this.getBlastEmployeeDataQuery.bind(this);
        this.getBlastEmployeeOverwriteDataQuery = this.getBlastEmployeeOverwriteDataQuery.bind(this);

        this.clearBlastLocationData = this.clearBlastLocationData.bind(this);
        this.clearBlastEmployeeData = this.clearBlastEmployeeData.bind(this);
        this.clearBlastEmployeeOverwriteData = this.clearBlastEmployeeOverwriteData.bind(this);
        this.clearTargetData = this.clearTargetData.bind(this);
        this.clearBlastData = this.clearBlastData.bind(this);

        this.saveAuthInfo = this.saveAuthInfo.bind(this);
        this.saveAccountInfo = this.saveAccountInfo.bind(this);
        this.saveSettingsInfo = this.saveSettingsInfo.bind(this);
        this.saveSetting = this.saveSetting.bind(this);

        this.saveBlastLocationData = this.saveBlastLocationData.bind(this);
        this.saveBlastEmployeeData = this.saveBlastEmployeeData.bind(this);
        this.saveBlastEmployeeOverwriteData = this.saveBlastEmployeeOverwriteData.bind(this);

        this.saveGroupsBlastLocationData = this.saveGroupsBlastLocationData.bind(this);
        this.saveGroupsBlastEmployeeData = this.saveGroupsBlastEmployeeData.bind(this);
        this.saveGroupsBlastEmployeeOverwriteData = this.saveGroupsBlastEmployeeOverwriteData.bind(this);

        this.saveBlastLocationDataFrom = this.saveBlastLocationDataFrom.bind(this);
        this.saveBlastEmployeeDataFrom = this.saveBlastEmployeeDataFrom.bind(this);
        this.saveBlastEmployeeOverwriteDataFrom = this.saveBlastEmployeeOverwriteDataFrom.bind(this);

        this.saveTargetData = this.saveTargetData.bind(this);

        this.removeInfo = this.removeInfo.bind(this);
    }

    init() {

    }

    dbExist() {
        return true; //maybe not a good idea. Not sure.
    }

    getAuthInfo() {
        let self = this;
        return new Promise((resolve, reject) => {

            if (zzDataCache.auth === undefined || zzDataCache.auth === null) {
                self.removeInfo();
                resolve({});
            } else {
                resolve(zzDataCache.auth);
            }
        });
    }

    getAccountInfo() {
        let self = this;
        return new Promise((resolve, reject) => {

            if (zzDataCache.account === undefined || zzDataCache.account === null) {
                self.removeInfo();
                resolve({});
            } else {

                resolve(zzDataCache.account);
            }
        });
    }

    getSettingsInfo() {
        return zzDataCache.settings;
    }

    getSetting(setting) {
        return zzDataCache.settings[setting];
    }

    saveAuthInfo(data) {

        return new Promise((resolve, reject) => {

            let newAuthInfo = {
                expires: data['.expires'],
                issued: data['.issued'],
                accessToken: data.access_token,
                refreshToken: data.refresh_token,
                expiresIn: data.expires_in,
                tokenType: data.token_type,
                userName: data.userName,
                userId: data.userId
            }

            zzDataCache.auth = newAuthInfo;
            window.localStorage.setItem('zzAuth', JSON.stringify(newAuthInfo));
            resolve();
        });
    }

    saveAccountInfo(response) {

        return new Promise((resolve, reject) => {

            let newAccountInfo = response;

            zzDataCache.account = newAccountInfo;
            window.localStorage.setItem('zzAccount', JSON.stringify(newAccountInfo));
            resolve();
        });
    }

    saveSettingsInfo(settings) {

        zzDataCache.settings = settings;
        window.localStorage.setItem("zzSettings", JSON.stringify(settings));
    }

    saveSetting(settingName, settingValue) {

        zzDataCache.settings[settingName] = settingValue;
        window.localStorage.setItem("zzSettings", JSON.stringify(zzDataCache.settings));

        return zzDataCache.settings;
    }

    clearBlastLocationData(callback) {
        zzDataCache.blastLocation = [];
        if (callback) {
            callback();
        }
    }

    clearBlastEmployeeData(callback) {
        zzDataCache.blastEmployee = [];
        if (callback) {
            callback();
        }
    }

    clearBlastEmployeeOverwriteData(callback) {
        zzDataCache.blastEmployeeOverwrite = [];
        if (callback) {
            callback();
        }
    }

    clearTargetData(callback) {
        zzDataCache.targets = null;
        if (callback) {
            callback();
        }
    }

    clearBlastData(callback) {
        let self = this;
        self.clearBlastLocationData(() => {
            self.clearBlastEmployeeData(() => {
                self.clearBlastEmployeeOverwriteData(() => {
                    self.clearTargetData(() => {
                        if (callback) {
                            callback();
                        }
                    });
                });
            });
        });
    }

    saveBlastLocationData(storeId, data, callback) {

        zzDataCache.blastLocation = zzDataCache.blastLocation.filter((obj) => {
            return !storeId.includes(obj.storeId);
        }).concat(data);

        zzDataCache.blastLocationMap = zzDataCache.blastLocation.reduce((r, e) => {
            let key = e.storeId + e.reportKpiId;
            if (!r[key]) {
                r[key] = e;
            } else {

            }

            return r;
        }, {});

        if (callback) {
            callback();
        }
    }

    saveBlastEmployeeData(storeId, data, callback) {

        zzDataCache.blastEmployee = zzDataCache.blastEmployee.filter((obj) => {
            return !storeId.includes(obj.storeId);
        }).concat(data);

        let myDataName = null;

        zzDataCache.blastEmployeeMap = zzDataCache.blastEmployee.reduce((r, e) => {
            let key = e.storeId + e.reportKpiId + e.employeeUniqueName + e.userId + e.isWorking + e.phone;
            if (!r[key]) {
                r[key] = e;
            } else {

            }

            if (zzDataCache.account != undefined && e.userId === zzDataCache.account.userId) {
                myDataName = e.name;
            }

            return r;
        }, {});

        zzDataCache.myDataName = myDataName;

        if (callback) {
            callback();
        }
    }

    saveBlastEmployeeOverwriteData(data, callback) {

        zzDataCache.blastEmployeeOverwrite = data;

        zzDataCache.blastEmployeeOverwriteMap = zzDataCache.blastEmployeeOverwrite.reduce((r, e) => {
            let key = e.reportKpiId + e.employeeUniqueName;
            if (!r[key]) {
                r[key] = e;
            } else {

            }

            return r;
        }, {});

        if (callback) {
            callback();
        }
    }

    saveGroupsBlastLocationData(storeId, data, callback) {

        let distInc = 0;
        let distUid = 0;
        let distData = data.reduce((r, e) => {

            let districts = e.districtName.split("|");
            districts.forEach(dist => {
                if (!r[dist]) {
                    r[dist] = {
                        id: distInc++,
                        locations: []
                    }
                }

                let tmpLoc = {};
                Object.keys(e).forEach(key => {
                    tmpLoc[key] = e[key];
                });
                tmpLoc.districtName = dist;
                tmpLoc.districtId = r[dist].id;
                tmpLoc.uId = tmpLoc.uId + (++distUid);

                r[dist].locations.push(tmpLoc);
            });

            return r;
        }, {});

        let locationBlastData = [];
        Object.values(distData).forEach(distDat => {
            distDat.locations.forEach(loc => {
                locationBlastData.push(loc);
            });
        })

        zzDataCache.blastLocation = locationBlastData;

        zzDataCache.blastLocationMap = zzDataCache.blastLocation.reduce((r, e) => {
            let key = e.storeId + e.reportKpiId;
            if (!r[key]) {
                r[key] = e;
            } else {

            }

            return r;
        }, {});

        if (callback) {
            callback();
        }
    }

    saveGroupsBlastEmployeeData(storeId, data, callback) {

        zzDataCache.blastEmployee = data;

        zzDataCache.blastEmployeeMap = zzDataCache.blastEmployee.reduce((r, e) => {
            let key = e.storeId + e.reportKpiId + e.employeeUniqueName + e.userId + e.isWorking + e.phone;
            if (!r[key]) {
                r[key] = e;
            } else {

            }

            return r;
        }, {});

        if (callback) {
            callback();
        }
    }

    saveGroupsBlastEmployeeOverwriteData(data, callback) {

        zzDataCache.blastEmployeeOverwrite = data;

        zzDataCache.blastEmployeeOverwriteMap = zzDataCache.blastEmployeeOverwrite.reduce((r, e) => {
            let key = e.reportKpiId + e.employeeUniqueName;
            if (!r[key]) {
                r[key] = e;
            } else {

            }

            return r;
        }, {});

        if (callback) {
            callback();
        }
    }

    async saveBlastLocationDataFrom(storeId, data, callback) {

        let properties = ["cYNOW", "cYWTD", "cYMTD", "cYQTD", "cYYTD"];
        data.forEach(item => {
            let key = item.storeId + item.reportKpiId;
            let curDat = zzDataCache.blastLocationMap[key];
            if (curDat) {
                properties.forEach(p => {
                    if (curDat[p] != undefined && item[p] != undefined) {
                        curDat[p] = item[p];
                    }
                });
            }
        });

        if (callback) {
            callback();
        }
    }

    async saveBlastEmployeeDataFrom(storeId, data, callback) {

        // zzDataCache.blastEmployee = zzDataCache.blastEmployee.filter((obj) => {
        //     return !storeId.includes(obj.storeId);
        // }).concat(data);

        let properties = ["cYNOW", "cYWTD", "cYMTD", "cYQTD", "cYYTD"];
        data.forEach(item => {
            let key = item.storeId + item.reportKpiId + item.employeeUniqueName + item.userId + item.isWorking + item.phone;
            let curDat = zzDataCache.blastEmployeeMap[key];
            if (curDat) {
                properties.forEach(p => {
                    if (curDat[p] != undefined && item[p] != undefined) {
                        curDat[p] = item[p];
                    }
                });
            }
        });

        if (callback) {
            callback();
        }
    }

    async saveBlastEmployeeOverwriteDataFrom(data, callback) {

        // zzDataCache.blastEmployeeOverwrite = data;

        let properties = ["cYNOW", "cYWTD", "cYMTD", "cYQTD", "cYYTD"];
        data.forEach(item => {
            let key = item.reportKpiId + item.employeeUniqueName;
            let curDat = zzDataCache.blastEmployeeOverwriteMap[key];
            if (curDat) {
                properties.forEach(p => {
                    if (curDat[p] != undefined && item[p] != undefined) {
                        curDat[p] = item[p];
                    }
                });
            }
        });

        if (callback) {
            callback();
        }
    }

    saveTargetData(data, callback) {

        zzDataCache.targets = data;

        if (callback) {
            callback();
        }
    }


    getBlastLocationDataQuery(storeId, districtId) {

        return new Promise((resolve, reject) => {

            let returnData = zzDataCache.blastLocation.filter((obj) => {
                if (districtId != undefined && districtId != null) {
                    return obj.districtId === districtId;
                } else if (storeId !== undefined && storeId !== null) {
                    return obj.storeId === storeId;
                } else {
                    return true;
                }
            });

            resolve(returnData);
        });
    }

    getBlastEmployeeDataQuery(storeId, employeeName) {

        return new Promise((resolve, reject) => {

            let returnData = zzDataCache.blastEmployee.filter((obj) => {
                if (storeId !== undefined && storeId !== null) {
                    return obj.storeId === storeId;
                } else {
                    return true;
                }
            });

            resolve(returnData);
        });

        // return new Promise((resolve, reject) => {

        //     let returnData = zzDataCache.blastEmployee.filter((obj) => {
        //         if (storeId !== undefined && storeId !== null) {
        //             return obj.companyId === companyId && obj.storeId === storeId;
        //         } else {
        //             return obj.companyId === companyId;
        //         }
        //     });

        //     resolve(returnData);
        // });
    }

    getBlastEmployeeOverwriteDataQuery() {
        return new Promise((resolve, reject) => {
            let returnData = zzDataCache.blastEmployeeOverwrite;

            resolve(returnData);
        });
    }

    removeInfo(callback) {

        zzDataCache.clearAll();
        if (callback) {
            callback();
        }
    }
}